import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import arrow_right_icon from '../../../asset/img/common/arrow_right_icon.svg';

import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import CheckBox from '../../../components/common/CheckBox';
import TextField from '../../../components/common/TextField';

import { kakaoTossSelectItem, personalInfoInputList } from '../../../common/data';
import { getAlertMessageFunction } from '../../../common/Util';
import { sendCertRequest, setUuid } from '../eDocumentsSlice';
import CheckBoxWithArrow from '../../../components/CheckBoxWithArrow';

const Step2 = ({
  stepHandler,
  selectedItem,
  setSelectedItem,
  check,
  handleCheckChange,
  isOpen,
  form,
  setForm,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('eDocuments');
  const { t: tCommon } = useTranslation('common');
  const inputList = personalInfoInputList(tCommon);
  const kakaoTossSelectItemList = kakaoTossSelectItem(t);

  const handleChange = e => {
    let { name, value } = e.target;
    if (name == 'htmPerBirth' || name == 'htmInsaPerHTel') {
      value = value.replace(/[^0-9]/g, '');
    }

    if (name == 'htmInsaPerHTel' && value.length > 11) {
      return;
    }

    if (name == 'htmPerBirth' && value.length > 8) {
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const clickCheckHandler = step => {
    stepHandler(step);
  };

  const handleSelectItem = value => {
    setSelectedItem(value);
  };

  const onSubmit = () => {
    const { htmInsaPerNm, htmPerBirth, htmInsaPerHTel } = form;
    const alertMessage = getAlertMessageFunction();

    //간편인증을 먼저 선택해주세요.
    if (!selectedItem) {
      alertMessage(t('linkToData.step2.alertMessage01'));
      return;
    }

    //개인정보 수집 이용 제공동의서에 동의해주세요.
    if (!check.personalInfoConsent) {
      alertMessage(t('linkToData.step2.alertMessage02'));
      return;
    }

    if (!check.personalInfoConsent2) {
      alertMessage(t('linkToData.step2.alertMessage07'));
      return;
    }

    //모든 항목을 입력해주세요.
    if (htmInsaPerNm?.trim() == '' || htmPerBirth?.trim() == '' || htmInsaPerHTel?.trim() == '') {
      alertMessage(t('linkToData.step2.alertMessage03'));
      return;
    }

    //생년월일을 8자리로 입력해주세요.
    if (htmPerBirth?.trim().length != 8) {
      alertMessage(t('linkToData.step2.alertMessage04'));
      return;
    }

    //올바른 휴대폰번호를 입력해주세요.
    if (htmInsaPerHTel?.trim().length != 11) {
      alertMessage(t('linkToData.step2.alertMessage05'));
      return;
    }

    const processedPhone = htmInsaPerHTel.startsWith('010')
      ? htmInsaPerHTel.slice(3)
      : htmInsaPerHTel;
    const provider = () => {
      if (selectedItem == '0') return 'kakao';
      if (selectedItem == '1') return 'toss';
      if (selectedItem == '2') return 'naver';
      if (selectedItem == '3') return 'kakaobank';
    };

    let formData = {
      provider: provider(),
      name: htmInsaPerNm?.trim(),
      birth: htmPerBirth?.trim(),
      phone: processedPhone?.trim(),
      // secretKey: 'Lwvw87zs3Nh1LiFDavMd',
    };

    sendCertRequestAPI(formData);
  };

  const sendCertRequestAPI = async formData => {
    try {
      const response = await dispatch(sendCertRequest(formData)).unwrap();
      console.log('response >>', response);
      const { resultCode, resultData } = response;
      if (resultCode == '1' && resultData) {
        dispatch(setUuid(resultData));
        stepHandler(4);
      } else {
        //인증요청에 실패했습니다. 다시 시도해주세요.
        alertMessage(t('linkToData.step2.alertMessage06'));
      }

      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        {/* 간편인증을 먼저 선택해 주세요! */}
        <Typography variant="body1Bold">{t('linkToData.description1')}</Typography>
        {/* 인증번호는 연말정산 자료 조회 외 다른 용도로는 이용되지 않습니다. */}
        <Typography variant="body1Medium">{t('linkToData.description2')}</Typography>
      </div>
      {/* 카카오 토스 선택 */}
      <div style={{ display: 'flex', gap: '24px', alignItems: 'center', justifyContent: 'center' }}>
        {kakaoTossSelectItemList.map((item, index) => (
          <div
            key={index}
            onClick={() => handleSelectItem(item.value)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '8px',
            }}>
            <img
              src={item.icon}
              alt="kakao_icon"
              style={{
                width: '50px',
                height: '50px',
                border: `${selectedItem === item.value ? '2px solid var(--Support-Pink)' : 'none'}`,
                boxShadow: `${
                  selectedItem === item.value ? '0px 0px 15px 0px rgba(254, 84, 147, 0.30)' : 'none'
                }`,
                borderRadius: '12px',
              }}
            />
            <Typography className="captionMedium">{item.label}</Typography>
          </div>
        ))}
      </div>

      {/* input 입력 */}
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {inputList.map(input => (
          <TextField
            size="small"
            key={input.key}
            label={input.label}
            value={form[input.key] || ''}
            name={input.key}
            onChange={handleChange}
            placeholder={input.placeholder}
          />
        ))}
      </div>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {/* 개인정보 이용 동의(필수) */}
        <CheckBoxWithArrow
          clickCheckHandler={() => clickCheckHandler(3)}
          check={check.personalInfoConsent}
          handleCheckChange={handleCheckChange}
          label={t('linkToData.checkBoxLabel')}
          name="personalInfoConsent"
        />
        {/* 개인정보 이용 동의(필수) */}
        <CheckBoxWithArrow
          clickCheckHandler={() => clickCheckHandler(6)}
          check={check.personalInfoConsent2}
          handleCheckChange={handleCheckChange}
          label={t('linkToData.checkBoxLabel2')}
          name="personalInfoConsent2"
        />
      </div>
      <div className="stepButtonContainer">
        <Button value={t('linkToData.button1')} fullWidth onClick={() => onSubmit()} />
      </div>
    </div>
  );
};

export default Step2;
